(function($) {

    /*
    *  new_map
    *
    *  This function will render a Google Map onto the selected jQuery element
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since 4.3.0
    *
    *  @param $el (jQuery element)
    *  @return  n/a
    */

    function new_map( $el, $county ) {

        var $markers = $($county).find('.map-trigger');

        // vars
        var args = {
            zoom    : 17,
            center    : new google.maps.LatLng(0, 0),
            mapTypeId : google.maps.MapTypeId.ROADMAP
        };


        // create map
        var map = new google.maps.Map( $el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        $markers.each(function(){
            add_marker( $(this), map );
        });


        // center map
        center_map( map );

        return map;

    }

    /*
    *  new_map
    *
    *  This function will refresh a Google Map onto the selected jQuery element
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since 4.3.0
    *
    *  @param $el (jQuery element)
    *  @return  n/a
    */

    function refresh_map($county) {
        var $markers;
        if ($county === 'all') {
            $markers = $('.ojl-locations-list').find('.map-trigger');
        } else {
            $markers = $($county).find('.map-trigger');
        }
        // vars
        var args = {
            zoom    : 16,
            center    : new google.maps.LatLng(0, 0),
            mapTypeId : google.maps.MapTypeId.ROADMAP
        };


        // Clear out the old markers.
        map.markers.forEach(function(marker) {
            marker.setMap(null);
        });

        // add a markers reference
        map.markers = [];

        markers = [];

        // add markers
        $markers.each(function(){
            add_marker( $(this), map );
        });


        // center map
        center_map( map );

        // return
        //return map;

    }

// function clearOverlays() {
//   for (var i = 0; i < map.markersArray.length; i++ ) {
//     markersArray[i].setMap(null);
//   }
//   markersArray.length = 0;
// }

    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since 4.3.0
    *
    *  @param $marker (jQuery element)
    *  @param map (Google Map object)
    *  @return  n/a
    */

    function add_marker( $marker, map ) {
        // var
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
        var icon = $marker.attr('data-img');
        // create marker
        var marker = new google.maps.Marker({
            position  : latlng,
            map     : map,
            icon        : icon
        });

        // add to array
        map.markers.push( marker );

        // if marker contains HTML, add it to an infoWindow
        if( $marker.find('.inside-marker').html() )
        {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content   : $marker.find('.inside-marker').html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {

                infowindow.open( map, marker );

            });
        }

    }

    /*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since 4.3.0
    *
    *  @param map (Google Map object)
    *  @return  n/a
    */

    function center_map( map ) {

        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each( map.markers, function( i, marker ){
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

            bounds.extend( latlng );

        });

        // only 1 marker?
        if( map.markers.length === 1 )
        {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 16 );
        }
        else
        {
            // fit to bounds
            map.fitBounds( bounds );
        }

    }

    /*
    *  document ready
    *
    *  This function will render each map when the document is ready (page has loaded)
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since 5.0.0
    *
    *  @param n/a
    *  @return  n/a
    */
// global var
    var map = null;

    $(document).ready(function(){

        if ($('.acf-map').length && typeof google !== 'undefined')
        {
            $('.acf-map').each(function () {
                // create map
                map = new_map($(this), '.county-group.Pääkaupunkiseutu');
            });

            $('.location-item__show-in-map .map-trigger').click(function () {
                var $data_lat = $(this).attr('data-lat');
                var $data_lng = $(this).attr('data-lng');
                map.setCenter({
                    lat: parseFloat($data_lat),
                    lng: parseFloat($data_lng)
                });
                map.setZoom(16);
                $('html, body').animate({
                    scrollTop: $(".acf-map").offset().top - 50
                }, 1000);
            });

            $('.ojl-locations-list #county-select').on('change', function () {
                var $selectedCounty = $(this).children("option:selected").val();
                if ($selectedCounty === 'all') {
                    $('.ojl-locations-list .county-group').show();
                    refresh_map('all');
                } else {
                    $('.ojl-locations-list .county-group').hide();
                    $('.ojl-locations-list .county-group.' + $selectedCounty).show();
                    var $mapSelector = '.county-group.' + $selectedCounty;
                    refresh_map($mapSelector);
                }

                $('html, body').animate({
                    scrollTop: $(".acf-map").offset().top - 50
                }, 1000);
            });

            $('.ojl-locations-list .county-select-wrapper span.display-all-regions').on('click', function () {
                $('.ojl-locations-list #county-select option[value="all"]').prop('selected', true);
                $('.ojl-locations-list .county-group').show();
                refresh_map('all');
                $('html, body').animate({
                    scrollTop: $(".acf-map").offset().top - 50
                }, 1000);
            });


            //zoom
            google.maps.event.addListener(map, 'zoom_changed', function (e) {

                var zoom = map.getZoom();

                if (zoom !== 5) {
                    var bounds = map.getBounds();

                    myLatLngss = [];
                    $.each(map.markers, function (i, marker) {
                        var myLatLng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

                        if (bounds.contains(myLatLng) === true) {
                            myLatLngss.push(myLatLng);
                        } else {

                        }
                    });
                    if (myLatLngss.length > 0) {
                        document.cookie = "coordn=" + myLatLngss;
                        $("#customzm").load(location.href + " #customzm");
                    }
                }

            });

            google.maps.event.addListener(map, 'dragend', function () {
                //alert('map dragged');
                var bounds = map.getBounds();

                myLatLngss = [];
                $.each(map.markers, function (i, marker) {

                    var myLatLng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

                    if (bounds.contains(myLatLng) === true) {
                        myLatLngss.push(myLatLng);
                    } else {

                    }
                    if (myLatLngss.length > 0) {
                        document.cookie = "coordn=" + myLatLngss;
                        $("#customzm").load(location.href + " #customzm");
                    }
                });

            });
        }


    });

})(jQuery);